export const Category = {
    path: '/categories',
    name: 'categories',
    component: () => import('@/views/Grille/Category/CategoryPage.vue'),
    children: [
        {
            path: '/categories/add',
            name: 'categories.add',
            component: () => import('@/views/Grille/Category/Form/CategoryForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/categories/edit/:id',
            name: 'categories.edit',
            component: () => import('@/views/Grille/Category/Form/CategoryForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/categories/delete/:id',
            name: 'categories.delete',
            component: () => import('@/views/Grille/Category/Form/CategoryForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/categories/view/:id',
            name: 'categories.view',
            component: () => import('@/views/Grille/Category/Form/CategoryForm.vue'),
            props: {viewAction: true}
        },
    ]
}